// extracted by mini-css-extract-plugin
module.exports = {"form-container":"Form_form-container__kMgUE","confirm-text":"Form_confirm-text__FrKEZ"};